module.exports = "/assets/89dba452b55196026ba73002107f28e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/LN.png
// module id = 1585
// module chunks = 0